module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp1-b8c3e3658669800c3d2f5c0a7be8e422.jpg";